export const T = {
  en_GB: {
    title: "Client access",
    description: "Choose who can see a client.",
    private: {
      title: "Private clients",
      explanation:
        "Advisors can mark a client as private. A private client is only visible to its owner.",
      advisorsDo: "Tick “Private” in the client dialog.",
    },
    team: {
      title: "Limit access with teams",
      explanation:
        "A client is only visible to its owner and the members of the client's teams. A client without teams is only visible to its owner.",
      advisorsDo: "Choose teams on each client; new clients get the creator's teams.",
    },
    privateWins: "Private always wins: a private client stays owner-only even if it has teams.",
    alwaysAll:
      "Admin and Compliance always see every client. The public API is not affected by these settings.",
    setUpTeams: "Set up teams",
    createTeams: "Create teams",
    noTeams: "No teams yet",
    teamCount: { one: "1 team", other: (n: number) => `${n} teams` },
    on: "on",
    off: "off",
    change: "Save",
    cancel: "Cancel",
    unsaved: "Preview — not saved. The client access settings have unsaved changes.",
    confirmTitle: "Change client access?",
    confirmSettings: (p: { private: string; team: string }) =>
      `Private clients: ${p.private}. Limit access with teams: ${p.team}.`,
    confirmFallback:
      "The client counts could not be loaded. The change applies to every client at once.",
    confirm: "Change",
    saved: "Saved",
    error: "Error",
    failedToSave: "Failed to change client access",
  },
  nb_NO: {
    title: "Tilgang til kunder",
    description: "Velg hvem som kan se en kunde.",
    private: {
      title: "Private kunder",
      explanation:
        "Rådgivere kan merke en kunde som privat. En privat kunde er bare synlig for eieren.",
      advisorsDo: "Kryss av for «Privat» i kundedialogen.",
    },
    team: {
      title: "Begrens tilgang med team",
      explanation:
        "En kunde er bare synlig for eieren og medlemmene av kundens team. En kunde uten team er bare synlig for eieren.",
      advisorsDo: "Velg team på hver kunde; nye kunder får teamene til den som oppretter dem.",
    },
    privateWins:
      "Privat vinner alltid: en privat kunde er bare synlig for eieren selv om den har team.",
    alwaysAll:
      "Admin og Compliance ser alltid alle kunder. Det offentlige API-et påvirkes ikke av disse innstillingene.",
    setUpTeams: "Sett opp team",
    createTeams: "Opprett team",
    noTeams: "Ingen team ennå",
    teamCount: { one: "1 team", other: (n: number) => `${n} team` },
    on: "på",
    off: "av",
    change: "Lagre",
    cancel: "Avbryt",
    unsaved:
      "Forhåndsvisning — ikke lagret. Innstillingene for tilgang til kunder har endringer som ikke er lagret.",
    confirmTitle: "Endre tilgang til kunder?",
    confirmSettings: (p: { private: string; team: string }) =>
      `Private kunder: ${p.private}. Begrens tilgang med team: ${p.team}.`,
    confirmFallback: "Kunne ikke hente antall kunder. Endringen gjelder alle kunder med en gang.",
    confirm: "Endre",
    saved: "Lagret",
    error: "Feil",
    failedToSave: "Kunne ikke endre tilgang til kunder",
  },
} as const;
